import React, { Component } from 'react';
import { Container } from 'flux/utils';
import { Card } from 'material-ui/Card';

import Checkbox from 'material-ui/Checkbox';
import DetailView from '../Common/DetailView';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table';
import AttributeStore from '../../stores/AttributeStore';
import UserActions from '../../actions/UserActionCreator';
import buildContextMenu from '../Common/BuildContextMenu';
import DownloadIcon from 'material-ui/svg-icons/file/file-download';
import PropTypes from "prop-types";
import ROLES from "../../constants/Roles";


const onSelectActive = (code, event, isInputChecked) => {
    const params = {active: isInputChecked};
    UserActions.setAttributeActive(code, params);
};

const onSelectRequired = (code, event, isInputChecked) => {
    const params = {required: isInputChecked};
    UserActions.setAttributeRequired(code, params);
};

const onSelectRegistration = (code, event, isInputChecked) => {
    const params = {shownOnRegistration: isInputChecked};
    UserActions.setAttributeRegistrationField(code, params);
};

const onSelectUserEditable = (code, event, isInputChecked) => {
    const params = {userEditable: isInputChecked};
    UserActions.setAttributeUserEditable(code, params);
};

const getRow = ({name, code, typeName, isActive, isRequired, shownOnRegistration, isUserEditable}) => (
    <TableRow>
        <TableRowColumn>{name}</TableRowColumn>
        <TableRowColumn>{code}</TableRowColumn>
        <TableRowColumn>{typeName}</TableRowColumn>
        <TableRowColumn><Checkbox id={`ac_${code}`} defaultChecked={isActive} onCheck={onSelectActive.bind(this, code)}/></TableRowColumn>
        <TableRowColumn><Checkbox id={`req_${code}`} defaultChecked={isRequired} onCheck={onSelectRequired.bind(this, code)}/></TableRowColumn>
        <TableRowColumn><Checkbox id={`onReg_${code}`} defaultChecked={shownOnRegistration} onCheck={onSelectRegistration.bind(this, code)}/></TableRowColumn>
        <TableRowColumn><Checkbox id={`usrEd_${code}`} defaultChecked={isUserEditable} onCheck={onSelectUserEditable.bind(this, code)}/></TableRowColumn>
    </TableRow>
);


class AttributeList extends Component {    
    componentDidMount() {
        UserActions.getAttributes();
    }

    render() {
        const tableProps = {
            fixedHeader: true
        };

        const tableHeaderProps = {
            displaySelectAll: false,
            adjustForCheckbox: false
        };

        const tableBodyProps = {
            displayRowCheckbox: false,
            showRowHover: true
        };


        return(
            <DetailView
                title="Attributes"
                actions={buildContextMenu([{
                    icon: <DownloadIcon />,
                    link: '/usr/attributes/export',
                    target: '_blank',
                    label: 'Export',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                }], this.context.auth)}
            >
                <div className='cent-cards'>
                    <Card className="cent-card">
                        <Table {...tableProps}>
                            <TableHeader {...tableHeaderProps}>
                                <TableRow>
                                    <TableHeaderColumn>Name</TableHeaderColumn>
                                    <TableHeaderColumn>Code</TableHeaderColumn>
                                    <TableHeaderColumn>Type</TableHeaderColumn>
                                    <TableHeaderColumn>Active</TableHeaderColumn>
                                    <TableHeaderColumn>Required</TableHeaderColumn>
                                    <TableHeaderColumn>Registration Field</TableHeaderColumn>
                                    <TableHeaderColumn>Editable by User</TableHeaderColumn>
                                </TableRow>
                            </TableHeader>
                            <TableBody {...tableBodyProps}>
                                {this.state.attributes.map(getRow)}
                            </TableBody>
                        </Table>
                    </Card>
                </div>
            </DetailView>
        )
    }    




}

AttributeList.getStores = () => ([AttributeStore]);

AttributeList.calculateState = (prevState) => ({attributes: AttributeStore.getAll()});

AttributeList.contextTypes = {
    auth:   PropTypes.object
};

export default Container.create(AttributeList);
